export default "__VITE_ASSET__CalkS1vJ__"